import { useState, useEffect } from 'react';
import config from 'config';

export const useOnlineStatus = () => {
  // Default to true for SSR to show online state initially
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    // Only access navigator.onLine after component mounts in browser
    setIsOnline(typeof window !== 'undefined' ? navigator.onLine : true);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    if (typeof window !== 'undefined') {
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);

      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      };
    }
  }, []);

  // Return false if either we're offline or offline mode is enabled
  return !config.enableOfflineMode || isOnline;
};
